import { AxiosResponse } from 'axios';

import { apiUtils } from './apiUtils';
import { endpoints } from './endpoints';

export type ApiPromise = Promise<AxiosResponse<any>>;

export const fdApi = {
  ...endpoints,
  ...apiUtils,
};
